export default {
  getXeroTenant: (state) => state.xeroTenant,
};
